const imageStates = new WeakMap();

const observer =
  typeof window !== "undefined" && "IntersectionObserver" in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            const state = imageStates.get(entry.target);
            if (state && state.src) {
              entry.target.src = state.src;
              state.loaded = true;
            }
            observer.unobserve(entry.target);
          });
        },
        {
          // Only start the request shortly before the image reaches the viewport.
          rootMargin: "300px 0px",
          threshold: 0.01,
        }
      )
    : null;

function observeImage(el, src) {
  const state = imageStates.get(el) || { loaded: false, src: "" };

  if (state.src === src) {
    return;
  }

  state.src = src || "";
  state.loaded = false;
  imageStates.set(el, state);

  if (observer) {
    observer.unobserve(el);
    el.removeAttribute("src");
    if (state.src) {
      observer.observe(el);
    }
    return;
  }

  // Older browsers get a functional eager-loading fallback.
  if (state.src) {
    el.src = state.src;
    state.loaded = true;
  }
}

export default {
  inserted(el, binding) {
    el.setAttribute("loading", "lazy");
    el.setAttribute("decoding", "async");
    observeImage(el, binding.value);
  },

  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      observeImage(el, binding.value);
    }
  },

  unbind(el) {
    if (observer) {
      observer.unobserve(el);
    }
    imageStates.delete(el);
  },
};
